

function stringFormat(strings, ...keys) {
    let res = '';
    const params = strings.split('{{');
    params.map((x, i) => {
        if (x.includes('}}')) {
            const end = x.split('}}');
            const index = end[0];
            res += keys[index];

            if (end.length > 1)
                res += end[1];
        } else {
            res += x;
        }
    });
    return res;
}

export {stringFormat}
